import { TableCell, tableCellClasses } from '@/core/ui';
import { styled } from '@mui/material';
export const TableCellRowSpanStyled = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'isLast',
})(({ theme, isLast }) => ({
    verticalAlign: 'top',
    [`&.${tableCellClasses.sizeSmall}`]: {
        paddingTop: theme.spacing(4), // TODO: make two variants: 1rem form normal table size, .875rem for small table size.
    },
    ...(isLast && { border: 'none' }),
}));
